"use strict";
exports.__esModule = true;
var alerts = (function () {
    var timeout;
    var secondsAlertActive = 10;
    var alertContainer = document.querySelector('.alerts-container');
    //Creates new alert, stores id of alert element, and runs interval if needed
    var createNewAlert = function (topicId, topic) {
        if (topicId === void 0) { topicId = ''; }
        if (topic === void 0) { topic = ''; }
        if (timeout)
            cleanupAlerts();
        var alertCopy = topicId != '' ?
            "Unchecked all ".concat(topic, "<br/> related products.") :
            "Your preferences have been saved!";
        var alertMessage = "\n      <div class=\"alert-message\">\n        <img src=\"/dist/images/icon-alert-".concat(topicId == '' ? 'saved' : 'updated', ".svg\" width=\"\" height=\"\" alt=\"\" />\n        <p>").concat(alertCopy, "</p>\n        <button class=\"alert-check\" data-topic='").concat(topicId, "'>Check</button>\n      </div>\n    ");
        alertContainer.innerHTML += alertMessage;
        timeout = window.setTimeout(cleanupAlerts, secondsAlertActive * 1000);
    };
    //Cleans up any alerts on page and in array if needed
    var cleanupAlerts = function () {
        clearTimeout(timeout);
        timeout = undefined;
        alertContainer.innerHTML = '';
    };
    //Open topic dropdown and close alert
    var handleUncheckedAlert = function (e) {
        var element = e.target;
        if (element.classList.contains('alert-check')) {
            var topic = element.getAttribute('data-topic');
            var topicList = document.querySelector("[data-topic-id=".concat(topic, "]")).closest('li');
            topicList.classList.add('active');
            cleanupAlerts();
        }
    };
    //Handle adding event listeners
    var handleEvents = function () {
        window.addEventListener('click', function (e) {
            handleUncheckedAlert(e);
        });
    };
    //Functions to run when parent is called
    var init = function () {
        handleEvents();
    };
    init();
    return { createNewAlert: createNewAlert };
}());
exports["default"] = alerts;
